import { IDateService } from '../../interface/date.interface';

export class BasicDateService extends Date implements IDateService {
    private _date!: Date;
    constructor(date: Date | string | number, parse?: Function) {
        if (parse) {
            super(parse(date));
        } else {
            super(date);
        }

        this._date = new Date(date);
    }

    public addDays(days: number): this {
        this.setDate(this.getDate() + days);
        return this;
    }

    public addMonths(months: number): this {
        this.setMonth(this.getMonth() + months);
        return this;
    }

    public addYears(years: number): this {
        this.setFullYear(this.getFullYear() + years);
        return this;
    }

    public subtractDays(days: number): this {
        this.setDate(this.getDate() - days);
        return this;
    }

    public subtractMonths(months: number): this {
        this.setMonth(this.getMonth() - months);
        return this;
    }

    public subtractYears(years: number): this {
        this.setFullYear(this.getFullYear() - years);
        return this;
    }

    public format(): string {
        return this.toDateString();
    }

    public toDate(): Date {
        return this;
    }

    public override getDay(): number {
        return this.getDate();
    }

    public getYear(): number {
        return this.getFullYear();
    }

    public setDates(date: number): this {
        this.setDate(date);
        return this;
    }

    public setMonths(month: number): this {
        this.setMonth(month);
        return this;
    }

    public setYears(year: number): this {
        this.setFullYear(year);
        return this;
    }

    public startOfDay(): this {
        this.setHours(0, 0, 0, 0);

        return this;
    }

    public startOfMonth(): this {
        this.setDate(1);
        return this.startOfDay();
    }

    public startOfYear(): this {
        this.setDate(1);
        this.setMonth(0);
        return this.startOfDay();
    }

    public isSameDay(date: this): boolean {
        return (
            this.getFullYear() === date.getFullYear() &&
            this.getMonth() === date.getMonth() &&
            this.getDate() === date.getDate()
        );
    }

    public isSameMonth(date: this): boolean {
        return (
            this.getFullYear() === date.getFullYear() &&
            this.getMonth() === date.getMonth()
        );
    }

    public isBefore(date: this): boolean {
        return this < date;
    }

    public isAfter(date: this): boolean {
        return this > date;
    }

    public isSameOrBefore(date: this | Date): boolean {
        return this <= date;
    }

    public differenceInDays(date: this | Date): number {
        return Math.ceil((this.valueOf() - date.valueOf()) / 1000 / 60 / 60 / 24);
    }

    public differenceInMonths(date: this | Date): number {
        let MONTH_DIFF: number =
            (new Date(date).getFullYear() - new Date(this).getFullYear()) * 12 +
            (new Date(date).getMonth() - new Date(this).getMonth());

        if (new Date(date).getDate() < new Date(this).getDate()) {
            MONTH_DIFF -= 1;
        }

        return MONTH_DIFF * -1;
    }
}
